<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">Diversion Books</span><br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1004<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Copyright © 2003 by Geoffrey Huntington</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</span></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a>.</span></p>
<p style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">First Diversion Books edition June 2013</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">ISBN: </span><span style="font-family: 'Liberation Serif', serif; font-size: 1em; line-height: 1.5; text-align: justify; text-indent: 1.5em;">978-1-626810-74-7</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h3 style="text-align: center;">
	For Brigid, Liam, Siobhan, Melissa, Matthew, and Dayna</h3>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap149091.vue?4eac9166